module.exports = __webpack_public_path__ + "img/banner02.ff685655.png";